import React, { PureComponent } from 'react';
import { UTCard, UTLabel, UTTouchableWithoutFeedback } from '@widergy/energy-ui';
import { string, func } from 'prop-types';

import { formsOptionsType } from 'types/turnsTypes';
import { message } from 'utils/stringUtils';

import { MONTHS, DAYS, REF_FORMS, REF_OFFICE, REF_CALENDAR, REF_SLOT } from './constants';
import styles from './styles.module.scss';

class CardCreateTurnContainer extends PureComponent {
  handleFormatData = (form, office, date, slot) => {
    if (!form || !office || !date || !slot) return {};
    const formFormatted = {
      label: form.label,
      key: REF_FORMS
    };
    const officeFormatted = {
      city: office.city,
      address: office.address,
      key: REF_OFFICE
    };
    const dateFormatted = {
      day: DAYS[date.getDay()],
      date: date.getDate(),
      month: MONTHS[date.getMonth()],
      key: REF_CALENDAR
    };
    const slotFormatted = {
      beginsAt: slot.begins_at,
      endsAt: slot.ends_at,
      key: REF_SLOT
    };

    return { formFormatted, officeFormatted, dateFormatted, slotFormatted };
  };

  render() {
    const { form, office, date, slot, onClick } = this.props;
    const data = this.handleFormatData(form, office, date, slot);
    const { formFormatted, officeFormatted, dateFormatted, slotFormatted } = data;
    const handleGoForm = () => onClick(formFormatted.key);
    const handleGoOffice = () => onClick(officeFormatted.key);
    const handleGoCalendar = () => onClick(dateFormatted.key);
    const handleGoSlot = () => onClick(slotFormatted.key);

    return (
      <div>
        <UTCard className={styles.card}>
          <UTLabel large bold className={styles.labelTitle}>
            {message('Turns:confirmatedTurn')}
          </UTLabel>
          <hr className={styles.divider} />
          <div className={styles.containerOptions}>
            <div className={styles.containerLabelOptions}>
              <UTLabel bold className={styles.labelOptionsTitle}>
                {message('Turns:confirmatedTurnTitle')}
              </UTLabel>
              <UTLabel className={styles.labelOptionsSubtitle}>
                {message('Turns:confirmatedTurnSubtitle')}
              </UTLabel>
            </div>
            <div className={styles.containersButtons}>
              <div className={styles.containerFormOffice}>
                {formFormatted && (
                  <UTTouchableWithoutFeedback className={styles.buttonOffice} onClick={handleGoForm}>
                    <UTLabel className={styles.labelButton}>
                      **{message('Commons:procedure')}** {formFormatted.label}
                    </UTLabel>
                  </UTTouchableWithoutFeedback>
                )}
                {officeFormatted && (
                  <UTTouchableWithoutFeedback className={styles.buttonOffice} onClick={handleGoOffice}>
                    <UTLabel className={styles.labelButton}>
                      **{message('Commons:office').toUpperCase()} {officeFormatted.city}**{' '}
                      {officeFormatted.address}
                    </UTLabel>
                  </UTTouchableWithoutFeedback>
                )}
              </div>
              <div className={styles.containerDaySlot}>
                {dateFormatted && (
                  <UTTouchableWithoutFeedback className={styles.buttonDay} onClick={handleGoCalendar}>
                    <UTLabel className={styles.labelButton}>
                      {dateFormatted.day} {dateFormatted.date} {message('Commons:of')} {dateFormatted.month}
                    </UTLabel>
                  </UTTouchableWithoutFeedback>
                )}
                {slotFormatted && (
                  <UTTouchableWithoutFeedback className={styles.buttonSlot} onClick={handleGoSlot}>
                    <UTLabel className={styles.labelButton}>
                      {slotFormatted.beginsAt} - {slotFormatted.endsAt}
                    </UTLabel>
                  </UTTouchableWithoutFeedback>
                )}
              </div>
            </div>
          </div>
        </UTCard>
      </div>
    );
  }
}

CardCreateTurnContainer.propTypes = {
  form: formsOptionsType,
  office: string,
  date: string,
  slot: string,
  onClick: func
};

export default CardCreateTurnContainer;
